import "core-js/modules/es6.object.create";

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

import React from 'react';

var MainCategory =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(MainCategory, _React$Component);

  function MainCategory() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MainCategory.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        children = _this$props.children;
    return React.createElement("div", {
      className: "subsection main-category"
    }, React.createElement("h3", {
      className: "title"
    }, title), children);
  };

  return MainCategory;
}(React.Component);

export default MainCategory;